/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type ForgotPasswordQueryVariables = {};
export type ForgotPasswordQueryResponse = {
    readonly configuration: {
        readonly passwordValidationRegex: string | null;
        readonly passwordValidationMessage: string | null;
    } | null;
};
export type ForgotPasswordQuery = {
    readonly response: ForgotPasswordQueryResponse;
    readonly variables: ForgotPasswordQueryVariables;
};



/*
query ForgotPasswordQuery {
  configuration {
    passwordValidationRegex
    passwordValidationMessage
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "Configuration",
            "kind": "LinkedField",
            "name": "configuration",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "passwordValidationRegex",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "passwordValidationMessage",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "ForgotPasswordQuery",
            "selections": (v0 /*: any*/),
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "ForgotPasswordQuery",
            "selections": (v0 /*: any*/)
        },
        "params": {
            "cacheID": "3ed1d1ce12ed91de129e6fe7873d77d1",
            "id": null,
            "metadata": {},
            "name": "ForgotPasswordQuery",
            "operationKind": "query",
            "text": "query ForgotPasswordQuery {\n  configuration {\n    passwordValidationRegex\n    passwordValidationMessage\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '2bd95512b91539358435fbc58a1597a3';
export default node;
